import { Box, Typography } from "@mui/material";
import React from "react";
import { getResponsiveSize } from "../../utils/responsive";
import globalStyles from "../../global";

const LocationBanner = ({
  prefix = "Now in", // Default value for the prefix text
  location = "Nepal", // Default value
  backgroundImage = "NepalBanner.png", // Default value
  primaryColor = globalStyles.colors.army_green,
  secondaryColor = "#61AB14",
}) => {
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  const getLocationFontSize = (locationName) => {
    const longLocationNames = ['BANGLADESH'];
    
    if (longLocationNames.includes(locationName)) {
      return {
        xs: getResponsiveSize(44.1), // Smaller size for long names on mobile
        sm: getResponsiveSize(120),
        md: getResponsiveSize(159.34),// Smaller size for long names on desktop
      };
    }
    
    return {
      xs: getResponsiveSize(59),
      sm: getResponsiveSize(120),
      md: getResponsiveSize(159.34),
    };
  };
  return (
    <Box
      sx={[
        styles.mainBox,
        {
          backgroundImage: {
            xs: `url(${imageBaseUrl}${backgroundImage})`,
            md: `url(${imageBaseUrl}${backgroundImage})`,
          },
        },
      ]}
    >
      <Box sx={styles.contentWrapper}>
        <Box sx={styles.titleWrapper}>
          <Typography sx={[styles.title, { color: primaryColor }]}>
            {prefix}
            <Typography 
              component="span" 
              sx={[styles.titleSpan, { color: secondaryColor,    fontSize: getLocationFontSize(location) }]}
              
            >
              {location}
            </Typography>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  mainBox: {
    minHeight: {
      xs: getResponsiveSize(300),
      sm: getResponsiveSize(400),
      md: getResponsiveSize(600),
    },
    width: "100%",
    py: { 
      xs: getResponsiveSize(4), 
      sm: getResponsiveSize(6) 
    },
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  contentWrapper: {
    width: "100%",
    maxWidth: {
      xs: "95%",
      sm: "90%",
      md: "80%"
    },
    mx: "auto",
    mb: {
      xs: getResponsiveSize(25),  // Increased margin bottom for mobile
      sm: getResponsiveSize(25), // Increased margin bottom for tablet
      md: getResponsiveSize(30)  // Increased margin bottom for desktop
    }
  },

  titleWrapper: {
    width: "100%",
    textAlign: { 
      xs: "center", 
      md: "center" 
    },
    mb: { 
      xs: getResponsiveSize(2), 
      sm: getResponsiveSize(3) 
    },
    px: { 
      xs: getResponsiveSize(2), 
      sm: 0 
    },
  },

  title: {
   fontFamily: ' "Poppins", serif ',
    fontWeight: 800,
    lineHeight: {
      xs: 1.2,
      sm: 1,
    },
    textAlign: "center",
    fontSize: {
      xs: getResponsiveSize(40),
      sm: getResponsiveSize(50),
      md: getResponsiveSize(65),
    },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  titleSpan: {
   fontFamily: ' "Poppins", serif ',
    fontWeight: 800,
    display: "block",
    textAlign: "center",
    mt: {
      xs: getResponsiveSize(0),
      sm: getResponsiveSize(0),
    },
  },
};

export default LocationBanner;